module.exports = __webpack_public_path__ + "assets/img/download.f8d493a9.svg";